import { render, staticRenderFns } from "./GenericMultiselect.vue?vue&type=template&id=28cc98e0&scoped=true&"
import script from "./GenericMultiselect.vue?vue&type=script&lang=ts&"
export * from "./GenericMultiselect.vue?vue&type=script&lang=ts&"
import style0 from "./GenericMultiselect.vue?vue&type=style&index=0&id=28cc98e0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc98e0",
  null
  
)

/* custom blocks */
import block0 from "./GenericMultiselect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports